// extracted by mini-css-extract-plugin
export var details = "_le-0";
export var inspectorPopover = "_le-1";